import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import GeneralLoading from "../../../shared-components/Loading";

export const ConfirmUploadDialog = ({
  open,
  setOpen,
  onConfirm,
  submitting,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          onSubmit: (event) => event.preventDefault(),
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>
        <Typography variant={"h4"}>Submit</Typography>
      </DialogTitle>
      <DialogContent>
        {submitting ? (
          <GeneralLoading message={"Submitting..."} />
        ) : (
          <Typography>Are you sure? This can't be undone.</Typography>
        )}
      </DialogContent>
      {!submitting && (
        <DialogActions>
          <Button
            type="button"
            onClick={() => setOpen(false)}
            variant={"contained"}
          >
            Cancel
          </Button>
          <Button type="button" onClick={onConfirm} variant={"outlined"}>
            Submit
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};
